import React, {useMemo} from 'react';
import PropTypes from 'prop-types';

import './TaskList.scss';
import {useDispatch, useSelector} from 'react-redux';
import {getCards, getTasksByType} from 'stores/selectors/cardStateSelector';
import {selectIsHumidifierInstalled} from 'stores/selectors/humidifierSelectors';
import {getValidCards} from 'lib/cardAndTaskHelper';
import HumiditySwitch from 'contents/HumidityControl/HumiditySwitch';
import {
  addHumidifierCardAndTask,
  removeHumidiferCardAndTask,
  updateHumidityLevel,
} from 'stores/business/taskListHumidifierBusiness';
import {TaskType} from 'constants/dataEnum';
import {setHumidifierError} from 'stores/actions/humidifierAction';

function TaskList({isReadOnly, children}) {
  const dispatch = useDispatch();
  const cards = useSelector(getCards);
  const isHumidifierInstalled = useSelector(selectIsHumidifierInstalled);
  const humidityTask = useSelector(getTasksByType(TaskType.ENABLE_HUMIDIFIER));
  const isHumidityEnabled = Boolean(humidityTask);

  const totalTipsForAllCards = useMemo(
    () => getValidCards(Object.values(cards)).reduce((acc, card) => acc + (card.requiredTips || 0), 0),
    [cards],
  );

  const handleToggleHumidityEnabled = (value) => {
    if (value === true) dispatch(addHumidifierCardAndTask());
    else dispatch(removeHumidiferCardAndTask());
  };

  return (
    <div className="task-list">
      <div className="task-list-header">
        <div className="title">
          <div className="text">Task List</div>
          <div className="tipsCount">{totalTipsForAllCards} tips</div>
        </div>
        <div className="separator" />
      </div>
      {isHumidifierInstalled && (
        <div className="humidity-control">
          <HumiditySwitch
            enabled={isHumidityEnabled}
            value={humidityTask?.humidityLevel}
            onChangeEnabled={(value) => handleToggleHumidityEnabled(value)}
            onChangeValue={(val) => {
              dispatch(updateHumidityLevel(val));
            }}
            onErrorChange={(error) => dispatch(setHumidifierError(error))}
            isReadOnly={isReadOnly}
          />
        </div>
      )}
      <div className="task-list-content block-scrollable">{children}</div>
    </div>
  );
}

TaskList.propTypes = {
  isReadOnly: PropTypes.bool,
  children: PropTypes.any,
};

TaskList.defaultProps = {
  isReadOnly: false,
  children: null,
};

export default TaskList;
